export const APPLICATION_COMPOSITIONS = [
    'PLATFORM_CONTROL_PLANE',
    'ORGANIZATION_RUNTIME',
    'COMBINED',
];
/**
 * Organization-owned product domains are deployment units, not personas.
 *
 * PORTFOLIO is the first released domain. Future organization domains such as
 * order management, accounting operations, HR, payroll, procurement, and CRM
 * must be added here only when they have an independently governed module
 * descriptor and composition module.
 */
export const ORGANIZATION_DOMAIN_MODULES = ['PORTFOLIO'];
export const DEFAULT_APPLICATION_COMPOSITION_PROFILE = Object.freeze({
    composition: 'COMBINED',
    organizationDomains: ['PORTFOLIO'],
});
export function validateApplicationCompositionProfile(profile) {
    if (!APPLICATION_COMPOSITIONS.includes(profile.composition)) {
        throw new Error(`Unsupported application composition: ${profile.composition}`);
    }
    const domains = [...new Set(profile.organizationDomains)];
    if (domains.length !== profile.organizationDomains.length) {
        throw new Error('Organization domain modules must be unique');
    }
    for (const domain of domains) {
        if (!ORGANIZATION_DOMAIN_MODULES.includes(domain)) {
            throw new Error(`Unsupported organization domain module: ${domain}`);
        }
    }
    if (profile.composition === 'PLATFORM_CONTROL_PLANE' && domains.length > 0) {
        throw new Error('Platform control-plane composition cannot include organization domains');
    }
    if (profile.composition === 'ORGANIZATION_RUNTIME' && domains.length === 0) {
        throw new Error('Organization runtime composition requires at least one organization domain');
    }
}
export function compositionIncludesPlatform(composition) {
    return composition === 'PLATFORM_CONTROL_PLANE' || composition === 'COMBINED';
}
export function compositionIncludesOrganizationRuntime(composition) {
    return composition === 'ORGANIZATION_RUNTIME' || composition === 'COMBINED';
}
